/* Предложенията под полето за търсене + допълване на непълна дума.
 *
 * ЗАЩО ГО ИМА: търсенето на Shopify не прави префиксно съвпадение за
 * кирилица („отсла" -> нищо, „отслабване" -> 256; за латиница работи).
 * Индексът (assets/tarsene-indeks.json, строи го scripts/tarsene-indeks.py)
 * се тегли при първи фокус в полето и всичко долу е при клиента:
 *   - продукти, категории и статии по префикс на дума;
 *   - „Търсения" - реални заявки от Search Console, които започват така;
 *   - при Enter непълната последна дума се допълва до най-честата дума, която
 *     започва с нея (само ако самата дума не съществува в индекса), за да
 *     стигне до Shopify цяла и страницата с резултати да има какво да покаже.
 *
 * Без скрипта формата е обикновена GET форма към /search - нищо не зависи оттук.
 */
(function () {
  'use strict';

  if (!window.fetch || window.__t4Tarsene) return;
  window.__t4Tarsene = true; /* скриптът се включва и от хедъра, и от страницата с резултатите */

  var indeks = null;
  var zarezhdane = null;
  var NASHA = 'билков рай';   /* данни, не текст: по него нашите излизат първи */
  var INDEKS_ADRES = null;

  function norm(s) {
    return String(s || '').toLowerCase().replace(/ё/g, 'е')
      .replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim();
  }

  function podgotvi(d) {
    var dumi = Object.create(null);
    function red(t) {
      var n = norm(t);
      n.split(' ').forEach(function (w) { if (w) dumi[w] = (dumi[w] || 0) + 1; });
      return n;
    }
    return {
      p: d.p.map(function (r) { return { h: r[0], t: r[1], v: r[2], n: red(r[1] + ' ' + (r[2] || '')), nasha: norm(r[2]).indexOf(NASHA) === 0 }; }),
      k: d.k.map(function (r) { return { h: r[0], t: r[1], b: r[2], n: red(r[1]) }; }),
      s: d.s.map(function (r) { return { h: r[0], t: r[1], n: red(r[1]) }; }),
      z: d.z.map(function (r) { return { t: r[0], b: r[1], n: norm(r[0]) }; }),
      dumi: dumi
    };
  }

  function zaredi() {
    if (indeks) return Promise.resolve(indeks);
    if (!zarezhdane) {
      zarezhdane = fetch(INDEKS_ADRES).then(function (r) { return r.json(); })
        .then(function (d) { indeks = podgotvi(d); return indeks; })
        .catch(function () { zarezhdane = null; return null; });
    }
    return zarezhdane;
  }

  /* всяка дума от заявката трябва да е начало на някоя дума в записа */
  function ocenka(zapis, tokeni, q) {
    var w = zapis.n.split(' ');
    var t = 0;
    for (var i = 0; i < tokeni.length; i++) {
      var tok = tokeni[i], nameren = false;
      for (var j = 0; j < w.length; j++) {
        if (w[j].indexOf(tok) === 0) { nameren = true; t += (j === 0 ? 2 : 1); break; }
      }
      if (!nameren) return 0;
    }
    if (zapis.n.indexOf(q) === 0) t += 3;
    if (zapis.nasha) t += 0.5;
    return t;
  }

  function tarsi(q) {
    var tokeni = q.split(' ').filter(Boolean);
    if (!tokeni.length) return null;
    function top(spisak, broy) {
      var s = [];
      for (var i = 0; i < spisak.length; i++) {
        var o = ocenka(spisak[i], tokeni, q);
        if (o > 0) s.push([o, spisak[i]]);
      }
      s.sort(function (a, b) { return b[0] - a[0] || (b[1].b || 0) - (a[1].b || 0); });
      return s.slice(0, broy).map(function (x) { return x[1]; });
    }
    return { p: top(indeks.p, 6), k: top(indeks.k, 4), s: top(indeks.s, 3), z: top(indeks.z, 4) };
  }

  /* всяка форма (хедър, страница с резултати) получава своя кутия и състояние */
  function vklyuchi(forma) {
  var pole = forma.querySelector('input[name="q"]');
  var kutia = forma.querySelector('[data-t4-predlozhenia]');
  if (!pole || !kutia) return;
  INDEKS_ADRES = INDEKS_ADRES || forma.dataset.indeks;
  var aktiven = -1;
  var poslednoQ = '';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* удебелява съвпадналото начало на думите */
  function podchertaj(tekst, tokeni) {
    var t = esc(tekst);
    if (!tokeni.length) return t;
    var r = new RegExp('(^|[\\s(„"\\-])(' + tokeni.map(function (x) { return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'giu');
    return t.replace(r, '$1<mark>$2</mark>');
  }

  function sekcia(zaglavie, elementi) {
    if (!elementi.length) return '';
    return '<div class="t4-predlozhenia__grupa"><p class="t4-predlozhenia__zaglavie t4-etiket">' + zaglavie + '</p>' + elementi.join('') + '</div>';
  }

  function pokazhi(q, rez) {
    var tokeni = q.split(' ').filter(Boolean);
    var html = '';
    if (rez) {
      html += sekcia(kutia.dataset.zProdukti || 'Продукти', rez.p.map(function (p) {
        return '<a class="t4-predlozhenia__el" role="option" href="/products/' + p.h + '"><span>' + podchertaj(p.t, tokeni) + '</span>' + (p.v ? '<small>' + esc(p.v) + '</small>' : '') + '</a>';
      }));
      html += sekcia(kutia.dataset.zKategorii || 'Категории', rez.k.map(function (k) {
        return '<a class="t4-predlozhenia__el" role="option" href="/collections/' + k.h + '"><span>' + podchertaj(k.t, tokeni) + '</span><small class="t4-chislo">' + k.b + '</small></a>';
      }));
      html += sekcia(kutia.dataset.zStatii || 'Статии', rez.s.map(function (s) {
        return '<a class="t4-predlozhenia__el" role="option" href="/blogs/' + s.h + '"><span>' + podchertaj(s.t, tokeni) + '</span></a>';
      }));
      html += sekcia(kutia.dataset.zTarsenia || 'Търсения', rez.z.map(function (z) {
        return '<a class="t4-predlozhenia__el t4-predlozhenia__el--zayavka" role="option" href="/search?q=' + encodeURIComponent(z.t) + '&type=product"><span>' + podchertaj(z.t, tokeni) + '</span></a>';
      }));
    }
    if (q) {
      /* връзката към пълните резултати носи допълнената дума - Shopify не
         намира „отсла", но намира „отслабване" */
      var qq = dopalni(q);
      html += '<a class="t4-predlozhenia__vsichki" role="option" href="/search?q=' + encodeURIComponent(qq) + '">' + (kutia.dataset.zVsichki || 'Всички резултати за') + ' „' + esc(qq) + '“</a>';
    }
    kutia.innerHTML = html;
    aktiven = -1;
    var ima = html !== '';
    kutia.hidden = !ima;
    pole.setAttribute('aria-expanded', ima ? 'true' : 'false');
  }

  /* празно поле: най-честите търсения като подсказка какво може да се пита */
  function pokazhiChesti() {
    var chesti = indeks.z.slice(0, 8);
    kutia.innerHTML = sekcia(kutia.dataset.zChesti || 'Търсени често', chesti.map(function (z) {
      return '<a class="t4-predlozhenia__el t4-predlozhenia__el--zayavka" role="option" href="/search?q=' + encodeURIComponent(z.t) + '&type=product"><span>' + esc(z.t) + '</span></a>';
    }));
    aktiven = -1;
    kutia.hidden = false;
    pole.setAttribute('aria-expanded', 'true');
  }

  function skrij() {
    kutia.hidden = true;
    pole.setAttribute('aria-expanded', 'false');
    aktiven = -1;
  }

  function obnovi() {
    var q = norm(pole.value);
    if (q === poslednoQ && !kutia.hidden) return;
    poslednoQ = q;
    if (!indeks) return;
    if (q.length < 2) { if (!q) pokazhiChesti(); else skrij(); return; }
    pokazhi(q, tarsi(q));
  }

  /* непълна последна дума -> най-честата дума в индекса, която започва така */
  function dopalni(q) {
    var tokeni = q.split(' ').filter(Boolean);
    if (!tokeni.length) return q;
    var posl = tokeni[tokeni.length - 1];
    if (posl.length < 3 || indeks.dumi[posl]) return q;
    var nay = null, nayBroy = 0;
    for (var w in indeks.dumi) {
      if (w.indexOf(posl) === 0 && indeks.dumi[w] > nayBroy) { nay = w; nayBroy = indeks.dumi[w]; }
    }
    if (!nay) return q;
    tokeni[tokeni.length - 1] = nay;
    return tokeni.join(' ');
  }

  var chasovnik = null;
  pole.setAttribute('role', 'combobox');
  pole.setAttribute('aria-autocomplete', 'list');
  pole.setAttribute('aria-expanded', 'false');
  pole.setAttribute('autocomplete', 'off');

  pole.addEventListener('focus', function () { zaredi().then(function () { if (indeks) obnovi(); }); });
  pole.addEventListener('input', function () {
    clearTimeout(chasovnik);
    chasovnik = setTimeout(function () { zaredi().then(function () { poslednoQ = null; if (indeks) obnovi(); }); }, 90);
  });
  pole.addEventListener('keydown', function (e) {
    var opcii = kutia.querySelectorAll('[role="option"]');
    if (e.key === 'Escape') { skrij(); return; }
    if (kutia.hidden || !opcii.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (aktiven >= 0) opcii[aktiven].removeAttribute('aria-selected');
      aktiven = e.key === 'ArrowDown' ? (aktiven + 1) % opcii.length : (aktiven - 1 + opcii.length) % opcii.length;
      opcii[aktiven].setAttribute('aria-selected', 'true');
      opcii[aktiven].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && aktiven >= 0) {
      e.preventDefault();
      window.location.href = opcii[aktiven].getAttribute('href');
    }
  });
  forma.addEventListener('submit', function () {
    if (indeks) {
      var q = norm(pole.value);
      var dop = dopalni(q);
      if (dop !== q) pole.value = dop;
    }
  });
  document.addEventListener('click', function (e) { if (!forma.contains(e.target)) skrij(); });
  /* mousedown вместо click: blur на полето иначе изпреварва избора */
  kutia.addEventListener('mousedown', function (e) { e.preventDefault(); });
  }

  document.querySelectorAll('form.t4-tarsene[data-indeks]').forEach(vklyuchi);
})();
